/**
 * @module state/reportError
 * Send an error report.
 */

import Immutable from "immutable";
import { select } from "redux-saga/effects";
import logger from "lib/log";
import * as appserver from "lib/appserver/request";
import { clearData } from "state/localStore";
import { getErrorCode } from "lib/error-details";

import { getUserIdentity } from "state/app/selectors";

/**
 * Log error locally and send report to appserver (BigBrother).
 */
export default function* reportErrorSaga(action) {

  const { error } = action.payload;

  clearData();
  logger.error(error);
  logger.log("ReportError: Sending error report...");

  // get payload from error details
  let payload;
  try {
    payload = JSON.stringify(error.details, undefined, 2);
  } catch (error) {
    logger.warn("ReportError: Failed to stringify error details:", error);
    payload = "[ failed to stringify error details ]";
  }

  let userIdentity;
  try {
    userIdentity = yield select(getUserIdentity);
  } catch (error) {
    logger.warn("ReportError: Could not get user identity from state:", error);
    userIdentity = new Immutable.Map();
  }

  // send error report
  return appserver.errorReport({
    type: (error && (error.type || error.name)) || "UnknownError",
    error_code: getErrorCode(error),
    message: error ? error.message : "Unknown",
    payload,
    stacktrace: error ? error.stack : "Unknown",
    web_version: process.env.REACT_APP_PACKAGE_VERSION,
    native_version: userIdentity.get("appVersion"),
    os: userIdentity.get("os"),
    os_version: userIdentity.get("osVersion"),
    device_type: userIdentity.get("device"),
    mobile_number: userIdentity.get("mobileNumber")
  })
    .then(response => {
      logger.log("ReportError: Sent error report. (response: %s)", response.data);
      return response;
    });

}



// WEBPACK FOOTER //
// ./src/state/reportErrorSaga.js